import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import FlexRow from '../../../../molecules/FlexRow'
import FastAvatar from '../../../../molecules/FastAvatar'
import Card from '../../../../molecules/Card'
import { useSearchAccounts } from '../../../../../api/accounts'

function AccountHeader ({ accountId }) {
  const query = useMemo(() => {
    return {
      filters: {
        accountId: [accountId]
      },
      includes: {
        avatars: true
      },
      take: 1
    }
  }, [accountId])
  const { data, isLoading } = useSearchAccounts(query)
  const account = useMemo(() => {
    return (data?.data || []).at(0)
  }, [data])

  if (isLoading) {
    return null
  }

  return (
    <Card>
      <FlexRow style={{ gap: '20px' }}>
        <FastAvatar avatarUrl={account?.avatarUrl} size='md' />
        <div>
          <Typography variant='h2'>{account.accountName}</Typography>
          {account.longName !== account.accountName ? (
            <Typography variant='h4'>{account.longName}</Typography>
          ) : null}
        </div>
        <div>
          <Typography variant='h2'>{account.accountNumber}</Typography>
        </div>
      </FlexRow>
    </Card>
  )
}

AccountHeader.propTypes = {
  accountId: PropTypes.number
}

export default AccountHeader
